import { Box, Button, Divider } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OrderStepper } from "./OrderStepper";
import PaymentIcon from "@mui/icons-material/Payment";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import {
  cancelOrder,
  fetchOrderById,
  getOrderItemById,
} from "../../../State/customer/OrderSlice";
import { OrderStatus } from "../../../types/orderTypes";
import {
  fetchProductById,
  fetchProductDetailById,
} from "../../../State/customer/ProductSlice";
export const OrderDetails = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { order, auth } = useAppSelector((store) => store);
  const { orderId, orderItemId } = useParams();
  const productsById = useAppSelector((s) => s.product.entities);
  const detailsById = useAppSelector((s) => s.product.entitiesDetails);
  // const product = productsById[order.orderItem?.productId!];
  // const detail = detailsById[order.orderItem?.productDetailId!];
  useEffect(() => {
    dispatch(fetchOrderById(Number(orderId)));
    dispatch(getOrderItemById(Number(orderItemId)));
  }, [dispatch, orderId, orderItemId]); // ✅ Runs only when orderId/orderItemId changes

  // useEffect(() => {
  //   // fetchProductById(item.productId)
  //   let productIds = []
  //   if(order.orderItem?.productId&&(dispatch(order.orderItem?.productId))),[order.currentOrder]}
  useEffect(() => {
    if (!order.currentOrder?.items) return;
    const items = order.currentOrder.items;
    const pids = Array.from(
      new Set(items.map((item) => item.productId).filter(Boolean))
    );
    const pdids = Array.from(
      new Set(items.map((item) => item.productDetailId).filter(Boolean))
    );
    pids.forEach((id) => dispatch(fetchProductById(id)));
    pdids.forEach((id) => dispatch(fetchProductDetailById(id)));
  }, [order.orderItem]);
  const handleCancelOrder = async (id: number | undefined) => {
    if (id != undefined) {
      await dispatch(cancelOrder(id)).unwrap();
    } else {
      return;
    }
  };
  const handleDeducted = (
    totalMrpPrice: number | undefined,
    totalSellingPrice: number | undefined
  ) => {
    let total = 0;
    if (totalMrpPrice != undefined && totalSellingPrice != undefined) {
      total = totalMrpPrice - totalSellingPrice;
     
      return total;
    }
  };


  return (
    <Box className="space-y-5 px-5">
      <h1 className="font-bold text-lg text-white text-center bg-gray-500 rounded-md">
        Order Number: {orderId}
      </h1>
      <div className="flex justify-center">
        {order.currentOrder?.items &&
          order.currentOrder.items.map((item) => {
            const prod = productsById[item.productId!];
            const det = detailsById[item.productDetailId!];
            return (
              <section className="flex flex-col gap-5 justify-center items-center">
                {prod?.images && (
                  <img className="w-[100px]" src={prod.images[0]} alt="" />
                )}
                <div className="text-sm space-y-1 text-center">
                  <h1 className="font-bold">
                    {prod?.sellerName}
                  </h1>
                  <p>{prod?.title}</p>
                  {det?.size && (
                    <p>
                      Size:
                      <strong> {det.size}</strong>
                    </p>
                  )}
                  {det?.color && (
                    <p>
                      Color:
                      <strong> {det.color}</strong>
                    </p>
                  )}
                  {item.quantity && (
                    <p>
                      Quantity:
                      <strong> {item.quantity}</strong>
                    </p>
                  )}
                </div>
                <div>
                  {/* .some(...) iterates over the reviews array.
It returns true if at least one review exists from the logged-in user.
If true → The button is disabled (because the user already reviewed the product).
If false → The button remains enabled, allowing the user to write a review. filtered out which review belong to who */}
                  <Button
                    disabled={
                      order.currentOrder?.orderStatus !== OrderStatus.SHIPPED ||
                      prod.reviews?.some(
                        (review) => review.user.id === auth.user?.id
                      )
                    }
                    onClick={() =>
                      navigate(
                        `/reviews/${order.currentOrder?.id}/${prod.id}/create`
                      )
                    }
                  >
                    Write Review
                  </Button>
                </div>
              </section>
            );
          })}
      </div>

      <section className="border p-5">
        <OrderStepper
          orderStatus={order.currentOrder?.orderStatus ?? "PLACED"}
        />
      </section>
      {/* Delivery Address section */}
      <div className="border p-5">
        <h1 className="font-bold pb-3">Delivery Address</h1>
        <div className="text-sm space-y-2">
          <div className="flex gap-5 font-medium">
            <p>{auth.user?.fullName}</p>
            <Divider flexItem orientation="vertical" />
            <p>{auth.user?.mobile}</p>
          </div>
          <p>
            {order.currentOrder?.shippingAddress.postalCode}{" "}
            {order.currentOrder?.shippingAddress.streetName}{" "}
            {order.currentOrder?.shippingAddress.city},{" "}
            {order.currentOrder?.shippingAddress.country}
          </p>
        </div>
      </div>
      {/* Payment section */}
      <div className="border space-y-4">
        <div className="flex justify-between text-sm pt-5 px-5">
          <div className="space-y-1">
            <p className="font-bold">Total Item Price</p>
            <p>
              You saved{" "}
              <span className="text-green-500 font-medium text-xs">
                €
                {handleDeducted(
                  order.currentOrder?.totalMrpPrice,
                  order.currentOrder?.totalSellingPrice
                )}
                .00
              </span>{" "}
              on this item
            </p>
          </div>
          <p className="font-medium">
            €{order.currentOrder?.totalSellingPrice}.00
          </p>
        </div>

        <div className="px-5">
          <div className="bg-teal-50 px-5 py-2 text-xs font-medium flex items-center gap-3">
            <PaymentIcon />
            <p>Paid By Card</p>
          </div>
        </div>
      </div>
      {/* Sold by and cancel button */}

      {/* Explanation of Parameters
name → Each element in the array.
index → The current index of name in the array.
self → The entire array itself (self is just a reference to the original array).
 */}
      {/* The .filter() method creates a new array with all elements that pass a test (provided as a function). It does not modify the original array. */}
      <Divider />
      <div className="p-5 pb-5">
        <p className="text-xs flex space-x-3">
          <strong>Sold by Businesses:</strong>
          <span className="space-x-2 text-gray-500">
            {order?.currentOrder?.items
              .map((item) => {
                const product = productsById[item.productId!];
                return product?.sellerName;
              }) // Extract names
              .filter(
                (name, index, self) => name && self.indexOf(name) === index
              ) // Remove duplicates
              .join(", ")}{" "}
            {/* {product?.seller.businessDetails.businessName&&(product?.seller.businessDetails.businessName)} */}
            {/* Join with ", " */}
          </span>
        </p>
      </div>

      <div className="p-10">
        {order.currentOrder != null && (
          <Button
            disabled={
              order.orderCanceled ||
              order.currentOrder.orderStatus !== OrderStatus.PENDING
            }
            // onClick={handleCancelOrder}
            color="error"
            sx={{ py: "0.7em" }}
            className=""
            variant="outlined"
            fullWidth
            onClick={() => {
              handleCancelOrder(order.currentOrder?.id);
            }}
          >
            {order.orderCanceled ? "Order Canceled" : "Cancel Order"}
          </Button>
        )}
      </div>
    </Box>
  );
};
